<template>
  <dara-item-table-layout>
    <template #avatar>
      <dara-user-link :id="user.id">
        <div class="d--flex direction--column align-items--center ml--sm mr--md">
          <dara-avatar size="md" :source="user.profile_pic" />
        </div>
      </dara-user-link>
    </template>
    <template #name>
      <el-tooltip v-if="fullname.length > 25" effect="dark" :content="fullname" placement="top">
        <dara-user-link :id="user.id" class="title">
          {{ fullname }}
        </dara-user-link>
      </el-tooltip>
      <dara-user-link v-else :id="user.id" class="title">
        {{ fullname }}
      </dara-user-link>
    </template>
    <template #firstColumn>
      {{ user.total_rating }}
    </template>
    <template #secondColumn>
      {{ user.created_articles }}
    </template>
    <template #thirdColumn>
      {{ user.readed_articles }}
    </template>
    <template #fourthColumn>
      {{ user.followers }}
    </template>
  </dara-item-table-layout>
</template>

<script>
import DaraItemTableLayout from '@/layouts/ItemTableLayout.vue';
import DaraUserLink from '@/modules/user/components/UserLink.vue';

export default {
  name: 'DaraUserRankingItem',
  components: {
    DaraItemTableLayout,
    DaraUserLink,
  },
  props: {
    user: Object,
  },
  computed: {
    fullname() {
      return `${this.user.name} ${this.user.last_name}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/scss/variables/colors';

  .title {
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .title:hover {
    color: $primary;
  }
</style>
